import React, { useEffect } from "react";

import { Card, Grid, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Theme } from "../../../Style/Theme";
import { HorizontalDivide } from "../../atoms/HorizontalDivide/HorizontalDivide";
import Content from "../../atoms/T&C/Content";
import { Heading } from "../../atoms/Typography/Heading/Heading";

const ContentWrapper = ({ lang }) => {
  const { i18n } = useTranslation();
  const { t } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(lang);
  }, [lang]);

  return (
    <div>
      <Card
        style={{
          display: "flex",
          backgroundColor: Theme.palette.background.paper,
          width: "auto",
          height: "auto",
          padding: "24px",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <Grid container display={"flex"} direction={"column"}>
          <Grid item>
            <Heading text={`${t(`glossary:termsandconditions.title`)}`} />
          </Grid>
          <Grid item style={{ marginTop: "12px", marginBottom: "40px" }}>
            <HorizontalDivide />
          </Grid>
          <Grid>
            <Content
              index={t("tnc:sections.section1.index")}
              title={t("tnc:sections.section1.title")}
              description={t("tnc:sections.section1.description")}
            />
            <Content
              index={t("tnc:sections.section2.index")}
              title={t("tnc:sections.section2.title")}
              description={t("tnc:sections.section2.description")}
            />
            <Content
              index={t("tnc:sections.section3.index")}
              title={t("tnc:sections.section3.title")}
              description={t("tnc:sections.section3.description")}
            />
            <Content
              index={t("tnc:sections.section4.index")}
              title={t("tnc:sections.section4.title")}
              description={t("tnc:sections.section4.description")}
            />
            <Content
              index={t("tnc:sections.section5.index")}
              title={t("tnc:sections.section5.title")}
              description={t("tnc:sections.section5.description")}
            />
            <Content
              index={t("tnc:sections.section6.index")}
              title={t("tnc:sections.section6.title")}
              description={t("tnc:sections.section6.description")}
            />
            <Content
              index={t("tnc:sections.section7.index")}
              title={t("tnc:sections.section7.title")}
              description={t("tnc:sections.section7.description")}
            />
            <Content
              index={t("tnc:sections.section8.index")}
              title={t("tnc:sections.section8.title")}
              description={t("tnc:sections.section8.description")}
            />
            <Content
              index={t("tnc:sections.section9.index")}
              title={t("tnc:sections.section9.title")}
              description={t("tnc:sections.section9.description")}
            />
            <Content
              index={t("tnc:sections.section10.index")}
              title={t("tnc:sections.section10.title")}
              description={t("tnc:sections.section10.description")}
            />
            <Content
              index={t("tnc:sections.section11.index")}
              title={t("tnc:sections.section11.title")}
              description={t("tnc:sections.section11.description")}
            />
            <Content
              index={t("tnc:sections.section12.index")}
              title={t("tnc:sections.section12.title")}
              description={t("tnc:sections.section12.description")}
            />
            <Content
              index={t("tnc:sections.section13.index")}
              title={t("tnc:sections.section13.title")}
              description={t("tnc:sections.section13.description")}
            />
            <Content
              index={t("tnc:sections.section14.index")}
              title={t("tnc:sections.section14.title")}
              description={t("tnc:sections.section14.description")}
            />
            <Content
              index={t("tnc:sections.section15.index")}
              title={t("tnc:sections.section15.title")}
              description={t("tnc:sections.section15.description")}
            />
            <Content
              index={t("tnc:sections.section16.index")}
              title={t("tnc:sections.section16.title")}
              description={t("tnc:sections.section16.description")}
            />
            <Content
              index={t("tnc:sections.section17.index")}
              title={t("tnc:sections.section17.title")}
              description={t("tnc:sections.section17.description")}
            />
            <Content
              index={t("tnc:sections.section18.index")}
              title={t("tnc:sections.section18.title")}
              description={t("tnc:sections.section18.description")}
            />
            <Content
              index={t("tnc:sections.section19.index")}
              title={t("tnc:sections.section19.title")}
              description={t("tnc:sections.section19.description")}
            />
            <Content
              index={t("tnc:sections.section20.index")}
              title={t("tnc:sections.section20.title")}
              description={t("tnc:sections.section20.description")}
            />
            <Content
              index={t("tnc:sections.section21.index")}
              title={t("tnc:sections.section21.title")}
              description={t("tnc:sections.section21.description")}
            />
            <Content
              index={t("tnc:sections.section22.index")}
              title={t("tnc:sections.section22.title")}
              description={t("tnc:sections.section22.description")}
            />
            <Content
              index={t("tnc:sections.section23.index")}
              title={t("tnc:sections.section23.title")}
              description={t("tnc:sections.section23.description")}
            />
            <Content
              index={t("tnc:sections.section24.index")}
              title={t("tnc:sections.section24.title")}
              description={t("tnc:sections.section24.description")}
            />
            <Content
              index={t("tnc:sections.section25.index")}
              title={t("tnc:sections.section25.title")}
              description={t("tnc:sections.section25.description")}
            />
          </Grid>
        </Grid>
      </Card>
    </div>
  );
};

export default ContentWrapper;
